import { useState } from 'react';
import { format } from 'date-fns';
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
} from '@web/components/ui/table';
import { PaymentItemData } from '@shared/types';

export default function PaymentTable({
  payments,
}: {
  payments: PaymentItemData[];
}) {
  const [expandedPayment, setExpandedPayment] = useState<number | null>(null);

  const togglePayment = (paymentId: number) => {
    setExpandedPayment(expandedPayment === paymentId ? null : paymentId);
  };

  return (
    <Table className="w-full border-collapse">
      <TableHeader>
        <TableRow>
          <TableCell className="px-4 py-3 text-left font-bold">
            Amount
          </TableCell>

          <TableCell className="px-4 py-3 text-left font-bold">Date</TableCell>

          <TableCell className="px-4 py-3 text-left font-bold">
            Payment Type
          </TableCell>

          <TableCell className="px-4 py-3 text-left font-bold">
            Payment Method
          </TableCell>
        </TableRow>
      </TableHeader>

      <TableBody>
        {payments.map((payment, paymentIndex) => (
          <TableRow
            key={paymentIndex}
            onClick={() => {
              togglePayment(paymentIndex);
            }}
            className="cursor-pointer border-b transition-colors duration-200"
          >
            <TableCell className="px-4 py-3 text-gray-800 dark:text-gray-200">
              {payment.amount}
            </TableCell>

            <TableCell className="px-4 py-3 text-gray-800 dark:text-gray-200">
              {payment.paymentDate
                ? format(new Date(payment.paymentDate), 'yyyy/MM/dd')
                : 'N/A'}
            </TableCell>

            <TableCell className="px-4 py-3 text-gray-800 dark:text-gray-200">
              {payment.paymentType}
            </TableCell>

            <TableCell className="px-4 py-3 text-gray-800 dark:text-gray-200">
              {payment.paymentMethod}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
